import React, {useState, useEffect} from 'react';
import {t} from 'react-switch-lang';
import {NavLink, Link} from 'react-router-dom';
import roles from '../../../utils/roles';
import {useUserContext} from '../../../contexts/UserContext';
import classes from './Reports.module.scss';
import {useDepartmentContext} from '../../../contexts/DepartmentContext';
const Subgroups = ({items, query, closeSidebar}) => {
  return (
    <>
      {items.map((item, index) => {
        return (
          <div
            className={`administration-link links ${classes['report-links']} ${
              query === item.link
                ? `active ${classes['report-links-active']}`
                : ''
            }`}
            key={index}
            onClick={() => closeSidebar()}
          >
            <Link to={item.link}>{item.text}</Link>
          </div>
        );
      })}
    </>
  );
};

const Groups = ({name, items, query, closeSidebar}) => {
  const [isOpen, setIsOpen] = useState(false);
  const maxHeight = `${items.length * 50}px`;

  useEffect(() => {
    items.map((a) => {
      if (query === a.link && isOpen === false) {
        setIsOpen(true);
      }
    });
  }, [query]);
  return (
    <div className={classes['navigation-group']}>
      <div className={classes['title']} onClick={() => setIsOpen(!isOpen)}>
        {name}
      </div>
      <div
        className={`${classes['children']} ${
          isOpen ? '' : classes['children-open']
        }`}
        style={{maxHeight: maxHeight}}
      >
        <Subgroups
          items={items}
          query={query}
          closeSidebar={() => closeSidebar()}
        />
      </div>
    </div>
  );
};

export const groupByGroupName = (arr) => {
  function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
      let key = obj[property];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }

  return groupBy(arr, 'group');
};

export function Reports({closeSidebar}) {
  const [showLink, setLink] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  var items = [];
  const departments = useDepartmentContext();
  const query = window.location.pathname;

  // const result = getReportsList(reportsList, resources, userRoles);

  const user = useUserContext();

  const userRoles = user.authorities;

  const difUserRoles = (array) => {
    const result = array.filter((element) => userRoles.includes(element));
    items = groupByGroupName(result);
    return result.length > 0;
  };
  useEffect(() => {
    if (Array.isArray(userRoles)) {
      setIsLoaded(true);
    }
  }, [userRoles]);

  let courtReports = departments.some((r) => [9].includes(r.id));
  let riskSector = user.authorities?.includes('ROLE_RISK_SECTOR');
  let riskSuperAdmin = user.authorities?.includes('ROLE_SUPER_ADMIN');

  const navigation = [
    {
      name: t('reports.measures'),
      link: '/reports/measures-report',
      text: t('reports.measures'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    courtReports ||
    riskSector ||
    riskSuperAdmin
      ? {
          name: t('reports.litigation'),
          link: '/reports/litigation-report',
          text: t('reports.litigation'),
          role: [
            roles.role_super_admin,
            roles.role_technological,
            roles.role_risk_sector,
            roles.role_user_in_charge,
            roles.role_responsible_user,
          ],
        }
      : null,
    {
      name: t('reports.occurredRiskReport'),
      link: '/reports/occurred-risk-report',
      text: t('reports.occurredRiskReport'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.riskLossReport'),
      link: '/reports/risk-loss-report',
      text: t('reports.riskLossReport'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.ORProductsProcesses'),
      link: '/reports/new-process-risk-report',
      text: t('reports.ORProductsProcesses'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.thirdPartiesReport'),
      link: '/reports/third-parties-risk-report',
      text: t('reports.thirdPartiesReport'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.kriReport'),
      link: '/reports/kri-report',
      text: t('reports.kriReport'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.kriReport2'),
      link: '/reports/kri-report-by-date',
      text: t('reports.kriReport2'),
      role: [
        roles.role_super_admin,
        roles.role_technological,
        roles.role_risk_sector,
        roles.role_user_in_charge,
        roles.role_responsible_user,
      ],
    },
    {
      name: t('reports.report-log'),
      link: '/reports/report-log',
      text: t('reports.report-log'),
      role: [roles.role_super_admin, roles.role_risk_sector],
    },
    {
      name: t('reports.revisions'),
      link: '/reports/revisions-report',
      text: t('reports.revisions'),
      role: [
        roles.role_super_admin,
        roles.role_admin,
        roles.role_head_of_internal_audit,
        roles.role_internal_auditor,
        roles.role_responsible_user,
        roles.role_internal_audit_responsible
      ],
    }
  ].filter((item) => item !== null);

  return (
    <div className="reports">
      <div className={classes['sidebar-title']}>{t('sidebar.reports')}</div>
      {isLoaded &&
        navigation.map((item, idx) => (
          <div key={idx}>
            {difUserRoles(item.role) ? (
              <NavLink
                activeClassName="active"
                className="administration-links links reports-tooltip-container"
                to={item.link}
                key={idx}
              >
                <div className="report-text">{item.name}</div>
                {item.name.length > 28 ? (
                  <div className="second-tooltip-text">
                    <span>{item.name}</span>
                  </div>
                ) : (
                  ''
                )}
              </NavLink>
            ) : null}
          </div>
        ))}
    </div>
  );
}
